<script setup lang="ts">
import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getUnifiedInquiry } from '@/api/inquiry/inquiry-unified-v2'
import { inquiryQuoteDetailRouteName } from './inquiry-quote-privilege'

const route = useRoute()
const router = useRouter()

const readQuery = (key: string) => {
  const value = route.query[key]
  return String(Array.isArray(value) ? value[0] : value || '').trim()
}

const readServiceType = (detail: unknown): string => {
  const root = (detail || {}) as Record<string, unknown>
  const fields = (root.fields || root.fieldMap || {}) as Record<string, unknown>
  const raw = fields.serviceType ?? fields.service_type ?? root.serviceType ?? root.service_type
  return String(raw || '').trim().toUpperCase()
}

onMounted(async () => {
  const bizType = readQuery('bizType')
  const inquiryId = String(route.params.inquiryId || readQuery('inquiryId') || '').trim()
  let name = inquiryQuoteDetailRouteName(bizType)
  const raw = bizType.toLowerCase()
  if (inquiryId && raw !== 'air' && raw !== 'lcl' && raw !== 'fcl') {
    try {
      const detail = await getUnifiedInquiry('fcl', { id: inquiryId })
      if (readServiceType(detail) === 'LCL') name = 'SaasInquiryQuoteLclDetail'
    } catch {
      name = 'SaasInquiryQuoteFclDetail'
    }
  }
  const nextBiz = name === 'SaasInquiryQuoteLclDetail'
    ? 'lcl'
    : name === 'SaasInquiryQuoteAirDetail'
      ? 'air'
      : 'fcl'
  router.replace({
    name,
    params: route.params.inquiryId ? { inquiryId: String(route.params.inquiryId) } : {},
    query: { ...route.query, inquiryId, bizType: nextBiz }
  })
})
</script>

<template>
  <div />
</template>
